// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"AddOrUpdate_placeholder__2VVLs"};